import { ELEMENT_PARAGRAPH } from '@doltech/utils/lib/constants';
import { Editor, Transforms } from 'slate';
import { ReactEditor } from 'slate-react';

export interface StrictNodeRule {
  type: string;
  getDefaultValue?: any;
  placeholder?: string;
}

export interface NormalizeTypeRule {
  /**
   * Force the type of the node at the given path
   */
  strictNode: StrictNodeRule;
  /**
   * Path where the rule applies
   */
  path: number[];
}

export interface WithForceNormalizeTypesOptions {
  rules: NormalizeTypeRule[];
}

export const withForceNormalizeTypes =
  (options: WithForceNormalizeTypesOptions) =>
  <T extends ReactEditor>(editor: T) => {
    const { normalizeNode } = editor;
    const { rules } = options;
    editor.normalizeNode = (entry) => {
      if (rules.length > 0) {
        for (let i = 0; i < rules.length; i++) {
          const rule = rules[i];
          const nodeProps = rule?.strictNode?.getDefaultValue() || {};
          let currentNode = null;
          let currentPath = null;
          try {
            [currentNode, currentPath] = Editor.node(editor, rule.path) as any;
          } catch (ex) {
            Transforms.insertNodes(editor, nodeProps, { at: rule.path });
          }
          if (currentNode) {
            if (currentNode?.type === ELEMENT_PARAGRAPH) {
              try {
                const [nextNode] = Editor.next(editor, { at: currentPath });
                if (nextNode?.type === rule.strictNode.type) {
                  // Transforms.removeNodes(editor, { at: currentPath });
                  return;
                }
                Transforms.setNodes(
                  editor,
                  { type: rule.strictNode.type, placeholder: rule?.strictNode?.placeholder },
                  { at: currentPath }
                );
                return;
                // eslint-disable-next-line no-empty
              } catch (ex) {}
            }
            if (currentNode?.type !== rule.strictNode.type) {
              // heading
              if (
                ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'].includes(
                  (rule?.strictNode?.type || '').toUpperCase()
                )
              ) {
                Transforms.setNodes(
                  editor,
                  { type: rule.strictNode.type, placeholder: rule?.strictNode?.placeholder },
                  { at: currentPath }
                );
                return;
              }

              Transforms.removeNodes(editor, { at: currentPath });
              Transforms.insertNodes(
                editor,
                {
                  ...nodeProps,
                  placeholder: rule?.strictNode?.placeholder,
                },
                {
                  at: currentPath,
                }
              );

              return;
            }
          }

          // node must have placeholder if rule defined
          if (rule?.strictNode?.placeholder && !currentNode?.placeholder) {
            Transforms.setNodes(
              editor,
              { placeholder: rule.strictNode.placeholder },
              { at: currentPath }
            );
            return;
          }
        }
      }

      // remove out of bound path
      const [, path] = entry;
      if (path.length === 1 && !rules.find((rule) => rule.path[0] === path[0])) {
        Transforms.removeNodes(editor, { at: path });
        return;
      }

      normalizeNode(entry);
    };

    return editor;
  };
